import React, { useContext, memo } from "react";
import {
  InfoWindow
} from "@react-google-maps/api";
import { WebMapContext } from "../WebMapGoogleMap";
import { TooltipType, geohashMiddle } from "../../../../constants/WebMap";
import OperatorTooltip from "../../../../components/elements/OperatorTooltip";
import DemandTooltip from "../../../../components/elements/DemandTooltip";

const SupplyDemandTooltipSection = ({
  eyeIcons,
  tooltipData,
  setTooltipData,
  geohashZoom
}) => {
  const {
    supplyFilters,
    mapZoomLevel
  } = useContext(WebMapContext);

  return (
    tooltipData
      ? (eyeIcons.supply && mapZoomLevel >= geohashZoom) ||
        (eyeIcons.demand && mapZoomLevel >= geohashZoom)
        ? <InfoWindow
          position={{
            lat: tooltipData.polygon[3].lat,
            lng: tooltipData.polygon[3].lng + geohashMiddle[tooltipData.geohash?.length || 7],
          }}
          onCloseClick={() => {
            setTooltipData(null);
          }}
          options={{ disableAutoPan: true }}
        >
          {eyeIcons.supply ? (
            <OperatorTooltip
              supplyType={supplyFilters.supplyType}
              geohashStat={tooltipData}
              anom={supplyFilters.anom}
              type={
                supplyFilters.isBestOperator
                  ? TooltipType.BEST
                  : TooltipType.NORMAL
              }
            />
          ) : eyeIcons.demand ? (
            <DemandTooltip
              headerData={tooltipData.header}
              bodyData={tooltipData.body}
              geohash={tooltipData.geohash}
            />
          ) : (
            <></>
          )}
        </InfoWindow>
        : <></>
      : <></>
  )
};

export default memo(SupplyDemandTooltipSection);